import IGlobalConfig from "../types/IGlobalConfig";
import { triggerCharityDeployment } from "./deploymentService";
import { ensureCustomizationData } from "../utils/firebase/customization";
import { saveBrandSetupData } from "../utils/firebase/brandSetup";

export interface PublishCharityCustomizationOptions {
  charityId: string;
  config: IGlobalConfig;
  serviceAccessToken: string;
  wlwSubdomain?: string;
}

export async function publishCharityCustomization({
  charityId,
  config,
  serviceAccessToken,
  wlwSubdomain,
}: PublishCharityCustomizationOptions): Promise<void> {
  const customizationData = await ensureCustomizationData(charityId);

  await triggerCharityDeployment(
    charityId,
    customizationData,
    config,
    serviceAccessToken,
    wlwSubdomain
  );

  await saveBrandSetupData(charityId, {
    progressTracker: "published",
    status: "completed",
    publishedAt: Date.now(),
  });
}
